import { Box } from "@mui/material";
import * as React from "react";
import PriceCompareTable from "./priceCompareTable";
import ShippingProfileSection from "./shippingProfileSection";

export default function Shipping(): React.ReactElement {
  return (
    <Box>
      <ShippingProfileSection />
      <PriceCompareTable />
    </Box>
  );
}
